import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalPlayers: null,
  location: null,
  date: null,
  slotData: [],
  selectedSlots: [],
  showSideBar: false,
  showCheckoutModal: false,
  totalAmount: 0,
  togglePlayerCountSelection: null,
  increaseTotalPlayer: false
};

const cBookingSlice = createSlice({
  name: "currentBookingSlice",
  initialState,
  reducers: {
    updateBookingData: (state, action) => {
      const { location, date, totalPlayers, selectedSlots } = action.payload;
      return {
        ...state,
        location,
        date,
        totalPlayers: totalPlayers || state.totalPlayers,
        selectedSlots: selectedSlots || state.selectedSlots,
        increaseTotalPlayer: false
      };
    },
    updateSlotData: (state, action) => {
      return { ...state,slotData: action.payload, selectedSlots: [], showCheckoutModal: false, showSideBar: false };
    },
    closeCheckOut: (state) => {
      return {...state,showCheckoutModal: false }
    },
    updateTotalPlayer: (state, action) => {
      return {...state,totalPlayers: action.payload }
    },
    setTotalAmount: (state, action) => {
      return {...state,totalAmount: action.payload }
    },
    toggleCheckoutModal: (state, action) => {
      return {...state,showCheckoutModal: action.payload }
    },
    updateBasicBookingInfo: (state, action) => {
      return {...state,increaseTotalPlayer: action.payload }
    },
    updateSelectedSlotData: (state, action) => {
      return { ...state, selectedSlots: action.payload };
    },
    updatePlayerCountSelection: (state, action) => {
      return { ...state, togglePlayerCountSelection: action.payload };
    },
    updateSlotDataAndPlayerCount: (state, action) => {
      return { ...state, 
        selectedSlots: action.payload.selectedSlots,
        togglePlayerCountSelection: action.payload.togglePlayerCountSelection };
    },
    setShowSideBar: (state, action) => {
      return { ...state, showSideBar: action.payload };
    },
    afterBookingCompletion: (state, action) => {
      return { ...state, selectedSlots: [], slotData: action.payload, showCheckoutModal: false };
    },
    clearCurrentBooking: (state) => {
      return { ...state, selectedSlots: [], showCheckoutModal: false, showSideBar: false };
    },
  },
});

export const {
  updateBookingData,
  clearCurrentBooking,
  updateSelectedSlotData,
  updateSlotData,
  afterBookingCompletion,
  setShowSideBar,
  toggleCheckoutModal,
  closeCheckOut,
  setTotalAmount,
  updateTotalPlayer,
  updatePlayerCountSelection,
  updateSlotDataAndPlayerCount,
  updateBasicBookingInfo
} = cBookingSlice.actions;
export default cBookingSlice.reducer;
